import actionCreatorFactory from "typescript-fsa";
import { CommonAsyncType } from "../../core/types";
import { BlogsRequestBody, BlogsResponse } from "../../core/api/request/blog/blogs/types";
import { BlogDetailRequestBody, BlogDetailResponse } from "../../core/api/request/blog/details/types";

const actionCreator = actionCreatorFactory("@@Blog");

export const blogActions = {
    getBlogs: actionCreator.async<CommonAsyncType<BlogsResponse> & BlogsRequestBody, BlogsResponse>("GET_BLOGS"), 
    getBlogDetail: actionCreator.async<CommonAsyncType<BlogDetailResponse> & BlogDetailRequestBody, BlogDetailResponse>("GET_BLOG_DETAIL"),
    resetToIntialState: actionCreator("RESET_TO_INITIAL_STATE"),
}
